import { FC } from 'react';

import { useAddCoOwnerModal } from './context/AddCoOwnerModalContext';
import AddCoOwnerModalHeader from './components/AddCoOwnerModalHeader';
import AddCoOwnerModalBody from './components/AddCoOwnerModalBody';
import AddCoOwnerModalFooter from './components/AddCoOwnerModalFooter';

const AddCoOwnerModal: FC = () => {
  const { data } = useAddCoOwnerModal();

  return (
    <>
      <AddCoOwnerModalHeader />
      <AddCoOwnerModalBody />
      <AddCoOwnerModalFooter />
    </>
  );
};

export default AddCoOwnerModal;
